import React from 'react';
import classNames from 'classnames';

// eslint-disable-next-line no-undef
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary';
  loading?: boolean;
  disable?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  loading = false,
  disable = false,
  className,
  children,
  leftIcon,
  rightIcon,
  onClick,
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      className={classNames(
        // Base styles
        'flex w-fit items-center justify-center gap-3 rounded-full leading-6',
        'cursor-pointer whitespace-nowrap transition-colors ease-in-out select-none',
        'first-letter:capitalize',
        'disabled:cursor-default',

        // Variant styles
        {
          'border-[0.75px] border-[#3FB988] bg-gradient-to-b from-transparent to-[rgba(63,185,136,0.60)] text-white backdrop-blur-[1.5px]':
            variant === 'primary',
        },
        // Disabled & Loading styles
        {
          'pointer-events-none opacity-70': disable || loading,
        },

        className
      )}
      onClick={onClick}
      {...props}>
      {/* Loading Indicator */}
      {loading && (
        <span className="animate-spin">
          <span>Loading...</span>
        </span>
      )}

      {/* Left Icon (if provided) */}
      {leftIcon && <span>{leftIcon}</span>}

      {/* Button Text */}
      {children}

      {/* Right Icon (if provided) */}
      {rightIcon && <span>{rightIcon}</span>}
    </button>
  );
};

export default Button;
